module.exports = __webpack_public_path__ + "zvetseni-prsou_17_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_17_after.jpg
// module id = 1307
// module chunks = 0